import { styled, Card, Box, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const ImageItemCont = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 8,
  margin: 10,
  transition: '300ms',
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.1)',
  },
  height: 'fit-content',
}));

export const ImageElement = styled('img')(({ theme }) => ({
  maxHeight: 144,
  borderRadius: 10,
  minWidth: 50,
  minHeight: 144,
}));

export const MainCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  height: '100%',
  alignContent: 'flex-start',
}));

export const VideoItemCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: 214,
  maxWidth: 333,
  minHeight: 214,
  minWidth: 333,
  borderRadius: 8,
  margin: 10,
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',
  [theme.breakpoints.down(960)]: {
    maxHeight: 'unset',
    maxWidth: 'unset',
    minHeight: 'unset',
    minWidth: 'unset',
  },

  //add class for button to show on hover
  '& .trim-button': {
    opacity: 0,
    transition: '300ms',
    pointerEvents: 'none',
  },

  '&:hover': {
    '& .trim-button': {
      opacity: 1,
      pointerEvents: 'all',
    },
  },

  '& svg path': {
    fill: COLORS.PRIMARY,
  },
}));

export const AudioItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 342,
  height: 53,
  borderRadius: 8,
  backgroundColor: theme.palette.type === 'dark' ? '#18212e' : COLORS.LIGHT_BORDER,
  margin: 10,
  alignItems: 'center',
  padding: '0px 15px',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down(960)]: {
    width: '-webkit-fill-available',
  },
}));

export const AudioInfo = styled(Box)(({ theme }) => ({
  marginLeft: 15,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const AudioName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 200,
  overflow: 'hidden',
  [theme.breakpoints.down(960)]: {
    width: 'calc(100% - 50px)',
  },
}));

export const Duration = styled(Box)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));
